// Outline action icons shared by the document listings (Drive documents, data
// room detail, round documents), so every Actions column renders the same set.
// Built on Lucide so they are stroked, not filled - the MUI equivalents these
// replaced (RemoveRedEye / Download / Delete) were solid glyphs and read much
// heavier than the rest of the UI.
import React from 'react';
import { Download, Eye, Trash2 } from 'lucide-react';

const STROKE = '#121212';
const STROKE_WIDTH = 1.6;

export const ViewDocumentIcon = ({ size = 19, color = STROKE }) => (
  <Eye size={size} color={color} strokeWidth={STROKE_WIDTH} />
);

export const DownloadDocumentIcon = ({ size = 19, color = STROKE }) => (
  <Download size={size} color={color} strokeWidth={STROKE_WIDTH} />
);

export const DeleteDocumentIcon = ({ size = 19, color = STROKE }) => (
  <Trash2 size={size} color={color} strokeWidth={STROKE_WIDTH} />
);
